import { Dialog } from "@mui/material";
import _ from "lodash";
import { useState, createContext, useRef, useContext } from "react";

///////////////////////////////////////////////////////////////////////////////////////////////
//  a boilerplate for opening/closing dialogs: one ugly side of react
///////////////////////////////////////////////////////////////////////////////////////////////
export type DialogParams = {
    id:string;
    className?:string;
    children:React.ReactNode;
    open:boolean;
    canClose?:() => boolean;
    onClose?:Function;
    onClosed?:Function;
}
export type DialogOptions = Omit<DialogParams, "open">;
export type OpenDialog = ((options:DialogOptions) => void)
export type CloseDialog = (() => void);
export type ProviderContext = {openDialog:OpenDialog,closeDialog:CloseDialog,dialogs:DialogParams[]};

const DialogContext = createContext<ProviderContext>({openDialog:() => {}, closeDialog:() => {},dialogs:[]});
export const useDialog = () => useContext(DialogContext!)

export default function DialogProvider(props:{children:JSX.Element|JSX.Element[]}) {
    const [dialogs,setDialogs] = useState<DialogParams[]>([])
    const openDialog:OpenDialog = (options:DialogOptions) => {
        const dialog = {...options, open:true}
        setDialogs((dialogs:DialogParams[]) => {
            return [...dialogs,dialog]
        })
    }
    const closeDialog:CloseDialog = () => {
        setDialogs((dialogs:DialogParams[]) => {
            const top = dialogs.pop()
            if (!top) return dialogs
            if (top.onClose) top.onClose()
            return [...dialogs].concat({...top, open:false})
        })
    }
    const contextValue = useRef<ProviderContext>({openDialog, closeDialog, dialogs})
    return <DialogContext.Provider value={contextValue.current}>
        {props.children}
        {dialogs.map((dialog:DialogParams,i:number) => {
            const {onClose,canClose, ...dialogParams} = dialog
            const onClosed = () => {
                if (dialog.onClosed) dialog.onClosed();
                
                setDialogs(dialogs => {
                    _.pull(dialogs, dialog)
                    return [...dialogs]
                })
            }
            const _onClose = () => {
                if (!canClose || canClose()) closeDialog()
            }
            return <DialogContainer key={dialog.id + i} {...dialogParams} onClose={_onClose} onClosed={onClosed}/>
        })}
    </DialogContext.Provider>
}

function DialogContainer(props:any){
    const {children,onClosed,...dialogProps} = props;
    return <Dialog {...dialogProps} TransitionProps={{ onExited:onClosed }}>{children}</Dialog>
}